/* eslint-disable react/prop-types */
import React from 'react';
import { connect } from 'react-redux';
import Slug from '../../../../components/slug/slug';
import Image from '../../../../components/eventsHub/atoms/Image';
import Card from '../../../../components/eventsHub/organisms/Card';
import FeatureCard from '../../../../components/eventsHub/organisms/FeatureCard';
import CardList from '../../../../components/eventsHub/organisms/CardList';
import { getEyebrowFromTags } from '../utils';
import Title from '../../../../components/eventsHub/atoms/text/Title';

const Discover = ({ videos }) => {
  const pageTitle = 'Videos';
  const pageDescription = `Explore our collection of past event 
    highlights below! From A-list keynotes to groundbreaking presentations with 
    industry leaders.`;

  return (
    <main className="eventsDiscover">
      <section className="events__header">
        <Slug slugName={pageTitle} className="category-page" />
        <p className="page-description">{pageDescription}</p>
      </section>

      {/* This is hardcoded for now -  https://mansueto.atlassian.net/browse/ENG-1400 */}
      <FeatureCard
        imgSrc={{
          mobile:
            'https://assets.fastcompany.com/image/upload/w_900,f_auto/v1700174762/Events%20Hub/i63Itejr-1920_1_2.webp',
          desktop:
            'https://assets.fastcompany.com/image/upload/w_1860,f_auto/v1700174762/Events%20Hub/i63Itejr-1920_1_2.webp'
        }}
        eyebrow="09-19-2023 | INNOVATION FESTIVAL"
        head={<Title text="The World According to Ray Dalio" xl element="h2" />}
        subhead="The economic and political landscapes are in constant turmoil. Get a better understanding of where the world is heading—and how you should plan accordingly—from the founder of the world’s largest hedge fund."
        cta={{
          text: 'Watch Now',
          href: '/events/video/the-world-according-to-ray-dalio/6529'
        }}
      />

      <CardList>
        {videos.map(video => {
          const [smImg, mdImg, lgImg] = video.thumbnailUrlResize;
          return (
            <Card
              key={video.id}
              image={
                <>
                  <div className="card_image_container">
                    <Image
                      src={video.thumbnailUrl}
                      alt={video.title}
                      srcSet={`${smImg} 807w, ${mdImg} 600w, ${lgImg} 420w`}
                      sizes="(max-width: 600px) calc(100vw - 60px), (max-width: 920px) calc(100vw / 2 - 40px), 280px"
                    />
                  </div>
                </>
              }
              eyebrow={getEyebrowFromTags(video?.internalTags)}
              title={video.title}
              description={video.description}
              href={`/events/video/${video.slug}/${video.id}`}
              showPlayIcon
            />
          );
        })}
      </CardList>
    </main>
  );
};

const mapStateToProps = state => ({
  videos: state.eventsPage.data.videos
});

export default connect(mapStateToProps)(Discover);
